import { query } from "src/utils/query";

import { fastApiEndpoint, isFailedResponse, responseToError } from "./fetcher";

export const switchSpace = async (
  id: string | null,
  to?: string,
): Promise<boolean> => {
  try {
    await fetch(`${import.meta.env.VITE_API_BASE_URL}/auth/switch-space`, {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify({
        spaceId: id,
      }),
    });
    window.location.href = to || "/";
    return true;
  } catch (error) {
    console.error(error);
  }
  return false;
};

export const switchWorkspace = async (
  id: string | number,
  to?: string,
  upgradeOptions?: {
    requestWritePermission: boolean;
    upgradeReason?: string;
    requestUserGroups?: string[];
    requestImpersonationType?: "readsupport";
  },
): Promise<boolean> => {
  try {
    const response = await fetch(
      `${import.meta.env.VITE_API_BASE_URL}/auth/switch-workspace`,
      {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          workspaceId: Number(id),
          ...(upgradeOptions || {}),
        }),
      },
    );
    // A refused switch leaves the session on its old workspace. Navigating
    // anyway sends callers that redirect by slug straight back here, forever.
    if (!response.ok) {
      return false;
    }
    window.location.href = to || "/";
    return true;
  } catch (error) {
    console.error(error);
  }
  return false;
};

export const adminSwitchWorkspace = async (slug: string, path?: string) => {
  const data = await query<{ workspaces?: { id: string }[] }>(
    `query WorkspaceBySlug($slug: String!) { workspaces(where: { slug: { _ilike: $slug } }) { id } }`,
    {
      slug,
    },
    {
      isAdmin: true,
    },
  );

  const id = data.workspaces?.[0]?.id;

  if (id) {
    return switchWorkspace(id, path);
  }
  return false;
};

export const verifyWorkspace = async (): Promise<void> => {
  const headers = {
    "Content-Type": "application/json",
  };

  const workspaceId = window.Hightouch?.workspaceId;

  if (workspaceId) {
    headers["X-Hightouch-Requested-Workspace-Id"] = String(workspaceId);
  }

  const res = await fetch(`${fastApiEndpoint}/verify-workspace`, {
    method: "GET",
    headers,
    credentials: "include",
  });

  if (isFailedResponse(res)) {
    throw await responseToError(res);
  }
};
